import { Country } from '.';

export const currencyCodes = ['GBP', 'USD', 'AUD', 'EUR', 'CAD'] as const;
export type Currency = (typeof currencyCodes)[number];

export const operationalCurrencyCodes = ['GBP', 'USD'] as const;
export type OperationalCurrency = (typeof operationalCurrencyCodes)[number];

export const currencyOptions: Array<{ [index in Currency]: { label: index; value: index } }[Currency]> = [
  { label: 'GBP', value: 'GBP' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
  { label: 'AUD', value: 'AUD' },
  { label: 'CAD', value: 'CAD' },
];

export const currencySymbols: Record<Currency, string> = {
  GBP: '£',
  USD: '$',
  EUR: '€',
  AUD: 'A$',
  CAD: 'CA$',
};

export const getCurrencyFromLocation = (location: Country): Currency => locationCurrencyCodeMapper[location];

export const locationCurrencyCodeMapper: { [location in Country]: Currency } = {
  AU: 'AUD',
  GB: 'GBP',
  EU: 'EUR',
  US: 'USD',
  CA: 'CAD',
  AD: 'USD',
  AE: 'USD',
  AF: 'USD',
  AG: 'USD',
  AL: 'USD',
  AM: 'USD',
  AO: 'USD',
  AQ: 'USD',
  AR: 'USD',
  AW: 'USD',
  AZ: 'USD',
  BA: 'USD',
  BB: 'USD',
  BD: 'USD',
  BF: 'USD',
  BH: 'USD',
  BI: 'USD',
  BJ: 'USD',
  BM: 'USD',
  BN: 'USD',
  BO: 'USD',
  BQ: 'USD',
  BR: 'USD',
  BS: 'USD',
  BT: 'USD',
  BW: 'USD',
  BY: 'USD',
  BZ: 'USD',
  CD: 'USD',
  CI: 'USD',
  CL: 'USD',
  CM: 'USD',
  CN: 'USD',
  CO: 'USD',
  CR: 'USD',
  CU: 'USD',
  CV: 'USD',
  CW: 'USD',
  DO: 'USD',
  DZ: 'USD',
  EC: 'USD',
  EE: 'USD',
  EG: 'USD',
  EH: 'USD',
  ET: 'USD',
  FJ: 'USD',
  FK: 'USD',
  FM: 'USD',
  FO: 'USD',
  GA: 'USD',
  GD: 'USD',
  GE: 'USD',
  GG: 'USD',
  GH: 'USD',
  GI: 'USD',
  GM: 'USD',
  GP: 'USD',
  GQ: 'USD',
  GR: 'USD',
  GT: 'USD',
  GU: 'USD',
  GY: 'USD',
  HK: 'USD',
  HN: 'USD',
  HR: 'USD',
  HT: 'USD',
  ID: 'USD',
  IL: 'USD',
  IN: 'USD',
  IQ: 'USD',
  IR: 'USD',
  IS: 'USD',
  JE: 'USD',
  JM: 'USD',
  JO: 'USD',
  JP: 'USD',
  KE: 'USD',
  KG: 'USD',
  KH: 'USD',
  KN: 'USD',
  KR: 'USD',
  KW: 'USD',
  KY: 'USD',
  KZ: 'USD',
  LA: 'USD',
  LB: 'USD',
  LC: 'USD',
  LI: 'USD',
  LK: 'USD',
  LS: 'USD',
  LT: 'USD',
  LU: 'USD',
  LV: 'USD',
  LY: 'USD',
  MA: 'USD',
  MC: 'USD',
  MD: 'USD',
  ME: 'USD',
  MG: 'USD',
  MK: 'USD',
  ML: 'USD',
  MM: 'USD',
  MN: 'USD',
  MO: 'USD',
  MQ: 'USD',
  MR: 'USD',
  MT: 'USD',
  MU: 'USD',
  MV: 'USD',
  MW: 'USD',
  MX: 'USD',
  MY: 'USD',
  MZ: 'USD',
  NA: 'USD',
  NC: 'USD',
  NE: 'USD',
  NF: 'USD',
  NG: 'USD',
  NI: 'USD',
  NP: 'USD',
  NZ: 'USD',
  OM: 'USD',
  PA: 'USD',
  PE: 'USD',
  PF: 'USD',
  PG: 'USD',
  PH: 'USD',
  PK: 'USD',
  PR: 'USD',
  PS: 'USD',
  PY: 'USD',
  QA: 'USD',
  RE: 'USD',
  RS: 'USD',
  RU: 'USD',
  RW: 'USD',
  SA: 'USD',
  SC: 'USD',
  SD: 'USD',
  SG: 'USD',
  SI: 'USD',
  SK: 'USD',
  SL: 'USD',
  SM: 'USD',
  SN: 'USD',
  SO: 'USD',
  SR: 'USD',
  SS: 'USD',
  SV: 'USD',
  SY: 'USD',
  SZ: 'USD',
  TD: 'USD',
  TG: 'USD',
  TH: 'USD',
  TJ: 'USD',
  TL: 'USD',
  TM: 'USD',
  TN: 'USD',
  TR: 'USD',
  TT: 'USD',
  TV: 'USD',
  TW: 'USD',
  TZ: 'USD',
  UA: 'USD',
  UG: 'USD',
  UY: 'USD',
  UZ: 'USD',
  VC: 'USD',
  VE: 'USD',
  VG: 'USD',
  VI: 'USD',
  VN: 'USD',
  VU: 'USD',
  XK: 'USD',
  YE: 'USD',
  YT: 'USD',
  ZA: 'USD',
  ZM: 'USD',
  ZW: 'USD',
  AT: 'EUR',
  BE: 'EUR',
  DK: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  IT: 'EUR',
  IE: 'EUR',
  NL: 'EUR',
  NO: 'EUR',
  PL: 'EUR',
  ES: 'EUR',
  SE: 'EUR',
  CH: 'EUR',
  CZ: 'EUR',
  HU: 'EUR',
  CY: 'EUR',
  PT: 'EUR',
  BG: 'EUR',
  RO: 'EUR',
};
